import { messages } from '@/js/app-bridge/messages'
import { ROGUE_APP_SPA_URL_PREFIX } from '@/js/app-bridge/helpers'
import { Rogue } from '@/js/services/Rogue'
import { loadRoute } from '@/js/router/loadRoutes'
import { useCategoryStore } from '@/js/stores/categoryStore'
import { useProductStore } from '@/js/stores/productStore'

function getLinkEl(e: MouseEvent): HTMLAnchorElement | boolean | null {
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return false
  // don't redirect when preventDefault called
  if (e.defaultPrevented) return false
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) return false

  if (e.target instanceof HTMLElement) {
    return e.target.closest('a')
  }

  return false
}

export function intercept(rogue: Rogue): void {
  if (typeof window !== 'undefined') {
    window.addEventListener('click', (e) => {
      const el = getLinkEl(e)

      if (!el || !(el instanceof HTMLAnchorElement)) {
        return
      }

      if (el.download) {
        return
      }

      if (!rogue.router || rogue.observeData.unrecoverableError) {
        return
      }

      let url = el.getAttribute('href') as string

      // Keep the app's processing on the top
      if (url && rogue.appContext) {
        const { origin, search } = window.location

        url = url.replace(/^\/\//, 'https://')
        if (url.startsWith(ROGUE_APP_SPA_URL_PREFIX)) {
          url = `${origin}${url}${search}`
        }

        if (el.getAttribute('target') === '_blank') {
          e.preventDefault()
          e.stopPropagation()
          rogue.emitToApp(messages.OPEN_IN_BROWSER, {
            url: url.startsWith(rogue.l10n.path) ? url.replace(`${rogue.l10n.path}/`, '/') : url,
          })

          return
        }

        if (/^https?:\/\/|^\/\/|^mailto:|^tel:/i.test(url)) {
          e.preventDefault()
          e.stopPropagation()

          const urlObj = new URL(url)
          if (url.includes(`/${rogue.l10n.path}/`) && url.indexOf('https://assets.roguefitness.com') !== 0) {
            rogue.router?.push({
              path  : urlObj.pathname,
              query : rogue.router?.currentRoute.value.query,
            })
          } else {
            rogue.emitToApp(messages.LINK_CLICK, { href: url })
          }

          return
        }
      }

      // don't redirect if `target="_blank"`
      if (el.getAttribute('target') === '_blank') {
        return
      }

      if ([undefined, null, rogue.router?.currentRoute.value.fullPath].includes(url)) {
        e.preventDefault()
        e.stopPropagation()

        return
      }

      if (url.match(/^https?:\/\/|^\/\/|^mailto:|^tel:|^\/?#/i)) {
        return
      }

      const categoryId = el.getAttribute('categoryId')
      const productId = el.getAttribute('productId')

      let withoutParams = url.split('?')[0].toLowerCase()

      if (rogue.l10n.path && withoutParams.startsWith(rogue.l10n.path + '/')) {
        withoutParams = withoutParams.substring(rogue.l10n.path.length)
      }

      if (categoryId) {
        const categoryStore = useCategoryStore(rogue.pinia)
        categoryStore.setIdForUrl(parseInt(categoryId, 10), withoutParams)
      } else if (productId && url.indexOf('sku=') === -1) {
        const productStore = useProductStore(rogue.pinia)
        productStore.setIdForUrl(withoutParams, parseInt(productId, 10))
      }

      if (e.preventDefault) {
        e.preventDefault()
      }

      loadRoute(withoutParams, rogue)
        .then(() => rogue.router?.push(url))
        .catch(err => {
          rogue.log.error('Error with link route push', err)
        })
    })
  }
}
